import React from "react";
import CTA from "../../components/LandingPage/CTA";
import Features from "../../components/LandingPage/Features";
import Hero from "../../components/LandingPage/Hero";
import Footer from "../../components/LandingPage/Footer";
import NavBar from "../../components/LandingPage/Navbar";

function Home() {
  return (
    <>
      <div className="w-100 min-vh-100 d-flex flex-column ">
        <Hero />
        <Features />
        <CTA />
      </div>
     
    </>
  );
}

export default Home;
